import React from 'react'

export const PowerBiDashboard = () => {
  return (
    <div style={{height:"100vh"}}>
        <iframe style={{height:"100%",width:"100%"}} title="FineOFS-SQL - Main"  src="https://app.powerbi.com/view?r=eyJrIjoiMGRhNjkyNjYtNWQwZC00N2I0LTk5OWYtNWVlZDAyYmM1NDQxIiwidCI6IjdjNDk0OTczLTBmOWYtNDMxZC05NWI4LTA0NTdmYzJmNzI4OCIsImMiOjl9" frameborder="0" allowFullScreen="true"></iframe>
    </div>
  )
}
